import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';
import store from 'store2';
import QsectionLookup from "../../components/Form/QsectionLookup";
import Groups12Input from "../../components/Form/Groups12Input";

const module = 'question';

export default class List extends Component {

	static contextTypes = {
		location: React.PropTypes.object
	};

	constructor(props, context) {
		super(props);

		const rendererLink = (val, row) => {
			const style = {
				width: 380,
				overflow: 'hidden',
				textOverflow: 'ellipsis'
			};
			return <div style={style}><a href={'/'+module+'/'+row.id} onClick={(e) => this.handleOpen(row, e)}>{val}</a></div>;
		};

		this.columnModel = [
			{
				name: 'id',
				title: 'ID',
				field: 'id',
				width: 20
			},
			{
				name: 'text',
				title: 'Otázka',
				field: 'text',
				width: 380,
				style: {whiteSpace: 'nowrap'},
				renderer: rendererLink
			},
			{
				name: 'sTitle',
				title: 'Oblast',
				field: 'sTitle',
				width: 250
			},
			{
				name: 'groups',
				title: 'Skupiny',
				field: 'groups',
				sortable: false,
				width: 240
			},
			{
				name: 'points',
				title: 'Bodů',
				field: 'points',
				align: 'center',
				width: 40,
        renderer: (value, row) => {
          if (value !== null) {
            return value;
          } else {
            return <span style={{color: "#BBB"}}>{row.sPoints}</span>;
          }

        }
			},
			{
				name: 'published',
				title: 'Aktivní',
				field: 'published',
				width: 60,
				renderer: Renderers.Check
			},
			{
				name: 'edit',
				title: 'Akce',
				field: 'id',
				width:80,
				sortable: false,
				renderer: (val, row) => {
					return (
						<a href={'/'+module+'/'+val} onClick={(e) => this.handleOpen(row, e)}>
							<i className="fa fa-pencil position-left"></i>Upravit
						</a>
					);
				}
			}
		];

		const filterSchema = {
			fulltext: { class: SearchInput },
			text: { class: FilterInput },
			sTitle: { class: QsectionLookup },
			groups: { class: Groups12Input },
			published: { class: Select, options: DbInfo.YesNo },
			edit: {
				class: FilterResetButton,
				visible: () => this.filter.isChanged(),
				onClick: () => this.filter.reset()
			}
		};
		this.filter = new FormManager(filterSchema);
		const sessionState = store.session.get('dg-' + module);
		// default
		let filter = {};
		// session
		if (sessionState && sessionState.filter) {
			filter = sessionState.filter;
		}
		this.defaultFilter = filter;
		this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {column: 'id', 'direction': 'desc'};

	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on(module + '.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener(module + '.change', this.changeListener);
	}

	handleOpen(row, e) {
		e.preventDefault();
		this.props.actions.openTabForm(module, row.text, row);
	}

	handleNewClick(e) {
		e.preventDefault();
		this.props.newTab();
	}

	render() {

		const buttons = <Button href={'/' + module + '/0'} onClick={(e) => this.handleNewClick(e)}>
			<i className="fa fa-plus position-left"/>Nová otázka
		</Button>;

		return (
			<Datagrid
				ref="datagrid"
				id={module}
				api="question.getList"
				buttons={buttons}
				filters={['fulltext']}
				filter={this.filter}
				saveState={true}
				getRowClassName={null}
				columnModel={this.columnModel}
				defaultFilter={this.defaultFilter}
				forceFilter={this.filterUrl}
				defaultSort={this.defaultSort}
			/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Question/List.js